import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Box } from "@chakra-ui/react";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Extend Day.js with plugins
dayjs.extend(utc);
dayjs.extend(timezone);

// Set default timezone
dayjs.tz.setDefault('Africa/Windhoek');

import { setDateRange } from "../../store/actions/defaultAction";
import AverlyDatePicker from "../averly/averly-date-picker";

const DatePicker = ({onDateRangeChange = null, calendarType = null, selectedDateRange = null}) => {
  const dispatch = useDispatch();
  const { dateRange, reportRange } = useSelector((store) => store.defaultReducer);
  selectedDateRange = selectedDateRange || dateRange;

  onDateRangeChange = onDateRangeChange || setDateRange;
  const handleDateChange = (date) => dispatch(onDateRangeChange(date));
  calendarType = calendarType ||  ((reportRange === 'realtime' || reportRange === 'ticket_info') ? 'day' : reportRange);

  // set maxDate to limit selecting future dates
  let maxDate = dayjs().endOf("month").unix();
  if(calendarType === "year") maxDate = dayjs().endOf("year").unix();
  if(calendarType === "week") maxDate = dayjs().endOf("week").unix();
  if(calendarType === "day") {maxDate = reportRange === 'ticket_info' ?  dayjs().endOf("day").unix() : dayjs().subtract(1, 'day').unix();}
  return (
    <Box 
      w="100%"
      h="56px"
      borderRadius="8px"
      border="1px solid #b0b0b0"
      p="12px 12px 9px 12px"
    >
      <AverlyDatePicker
        styling={{ 
          width: "100%", 
          height: "20px", 
          fontSize: "16px", 
          spacing: "10px", 
          calendar: {
            placement: ["top", "left"], //vertical(top, bottom), horizontal(left, right)
            spacing: ["30px", "-13px"], //vertical, horizontal
          }
        }}
        label={calendarType}
        calendarType={calendarType} // month, week, day
        maxDate={maxDate}
        value={selectedDateRange.length && selectedDateRange[0].toString().length ? selectedDateRange : [dayjs().startOf("month").unix(), ""]}
        onChange={handleDateChange}
      />
    </Box>
  );
};

export default DatePicker;
